export const SET_AUCTION_LOGO = "SET_AUCTION_LOGO";
export const SET_AUCTION_SLUG = "SET_AUCTION_SLUG";

export const setAuctionLogo = (logo) => ({
  type: SET_AUCTION_LOGO,
  payload: logo,
});
export const setAuctionSlug = (slug) => ({
  type: SET_AUCTION_SLUG,
  payload: slug,
});
